import { useLocation, useNavigate } from 'react-router-dom';
import { isAllTabInUse } from '../selectors/tabs-selectors';
import { AppTemplate } from '@wix/ambassador-devcenter-apps-v1-app-template/types';
import { useQueryParam } from './useQueryParam';
import { QueryParams } from '../constants/QueryParams';
import { scrollBodyToTop } from '../utils/scrollBodyToTop';
import {
  filterToUrlParamMapper,
  UrlParams,
  urlParamToFilterMapper,
} from '../utils/urlParams-utils';
import { TemplateTab } from '../types/TemplateTabs';
import { APP_BASE_ROUTE, APP_PAGES } from '../constants/routes';

export const usePageNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setParam, removeParam, getParam } = useQueryParam();
  const templateId = getParam(QueryParams.ID);
  const filterParamInUrl = getParam(QueryParams.FILTER);
  const appliedFilter = urlParamToFilterMapper[filterParamInUrl];
  const currentOriginTab = location?.state?.originTab;

  const openBlocksTemplateFlow = (templateId: string, templateName: string) => {
    window.open(
      `${APP_BASE_ROUTE}${APP_PAGES.OPEN_BLOCKS_TEMPLATE_ROUTE}?${QueryParams.TEMPLATE_ID}=${templateId}&${QueryParams.TEMPLATE_NAME}=${templateName}`,
    );
  };

  const navigateToMainPage = () => {
    navigate({
      pathname: '/',
      ...(currentOriginTab && {
        search: `?${QueryParams.FILTER}=${currentOriginTab}`,
      }),
    });
    scrollBodyToTop();
  };

  const navigateToTemplate = (
    template: AppTemplate,
    originTab: UrlParams | undefined = currentOriginTab,
  ) => {
    if (template?.previewUrl) {
      navigate(
        {
          pathname: '/template',
          search: `?${QueryParams.ID}=${template.id}`,
        },
        { state: { originTab } },
      );
      scrollBodyToTop();
    } else {
      openBlocksTemplateFlow(template.id, template.title);
    }
  };

  const setParamAccordingToTab = (chosenTab: TemplateTab) => {
    const chosenTabToUrlParam = filterToUrlParamMapper?.[chosenTab];
    if (isAllTabInUse(chosenTab)) {
      removeParam(QueryParams.FILTER);
    } else {
      setParam(QueryParams.FILTER, chosenTabToUrlParam);
    }
  };

  return {
    navigateToTemplate,
    setParamAccordingToTab,
    navigateToMainPage,
    appliedFilter,
    templateId,
    openBlocksTemplateFlow,
  };
};
